import React, { useEffect } from 'react';
import './WelcomePage.scss';

import { trackEvent, SectionLoaded } from '../../utils/mixpanel';
import homeImg from '../../assets/images/home.svg';
import { BORROWER_DASHBOARD_URL } from '@common/config/environments';

interface WelcomePageProps {
  onContinue?: () => void;
  onBrokerContinue?: () => void;
}

export const WelcomePage = (props: WelcomePageProps) => {
  const { onContinue, onBrokerContinue } = props;

  useEffect(() => {
    // Track page load event with additional error handling
    const trackPageLoad = () => {
      try {
        const event = SectionLoaded('Welcome Page');
        trackEvent(event);
      } catch (error) {
        console.warn('Failed to track Welcome Page event:', error);
      }
    };
    
    // Add a small delay to ensure Mixpanel is fully initialized
    const timeoutId = setTimeout(trackPageLoad, 100);
    
    return () => clearTimeout(timeoutId);
  }, [])
  
  return (
    <div className='welcome-page'>
      <div className='left-column'>
        <div className='content'>
          <div className='welcome'>
            <h1>{`Price your loan with Constitution Lending!`}</h1>
            <p>{`We're going to ask you a few questions to get you the most accurate term sheet. If you don't know something, just estimate. Also, please note, we only do loans for investment properties.`}</p>
          </div>

          <div className='rate' onClick={onContinue}>
            {`Give me my rate!`}
          </div>

          <div className='broker' onClick={onBrokerContinue}>
            <span>
              {"I'm a broker -->"}
            </span>
          </div>

          <p className='account'>
            Already have an account? <span onClick={() => { window.location.href = `${BORROWER_DASHBOARD_URL}/login` }}>Sign in</span>
          </p>
        </div>
      </div>
      <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" alt="Star icon" onError={(e) => {
                console.warn('Failed to load star image:', e);
                e.currentTarget.style.display = 'none';
              }} />
            </div>
            <p className="phrase">
              {`"Dealing with multiple lenders is SO exhausting and wondering if I'd get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!"`}
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
          <img className="home" src={homeImg} alt="Home illustration" onError={(e) => {
            console.warn('Failed to load home image:', e);
            e.currentTarget.style.display = 'none';
          }} />
          </div>
        </div>
    </div>
  );
}
